module.exports = __webpack_public_path__ + "h5/img/fuwuqi.7c1e0ae4.png";